// Product catalog with real brochure images extracted from client PDF.
const B = "/assets/products/brochure";

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "nutritional", label: "Nutritional" },
  { id: "antibiotics", label: "Antibiotics" },
  { id: "liver", label: "Liver Tonics" },
  { id: "antiparasitics", label: "Antiparasitics" },
  { id: "mastitis", label: "Mastitis Care" },
  { id: "uterine", label: "Uterine Care" },
  { id: "nsaids", label: "NSAIDs" },
  { id: "allergy", label: "Allergy" },
];

export const PRODUCTS = [
  {
    slug: "chelated-calcitonic-ds",
    name: "Chelated Calcitonic-DS Liquid",
    category: "nutritional",
    categoryLabel: "Nutritional",
    tagline: "Health Tonic for High Yielders During Early Lactation",
    images: [
      "/assets/products/calcitonic-ds-brand.jpeg",
      "/assets/products/calcitonic-ds-range.jpeg",
      "/assets/products/calcitonic-ds-bottle1.jpeg",
      "/assets/products/calcitonic-ds-bottle2.jpeg",
      "/assets/products/calcitonic-ds-farm.jpeg",
      "/assets/products/calcitonic-ds-buffalo.jpeg",
      "/assets/products/calcitonic-ds-hindi.jpeg",
    ],
    composition: "Calcium, Phosphorus, Vitamins D3 / B12 / E, Biotin, Chelated Zinc, Chelated Copper, Potassium Iodine, Silymarin, Jivanti, Shatavari.",
    indications: [
      "Improves milk production & milk fat (SNF)",
      "Strengthens udder immunity",
      "Reduces metabolic disorders (milk fever, hypocalcemia)",
      "Supports bone strength in early lactation",
    ],
    dosage: [
      ["Cattle / Buffalo", "100 ml daily"],
      ["Calves", "20 ml twice daily"],
      ["Chicks / Poultry", "20 ml per 100 birds"],
    ],
    pack: "1 Litre, 5 Litre, 10 Litre, 20 Litre",
    featured: true,
  },
  {
    slug: "apna-liv-ts",
    name: "Apna Liv-TS",
    category: "liver",
    categoryLabel: "Liver Tonic",
    tagline: "Protect the Liver — Regenerate. Restore. Revive.",
    images: [`${B}/apna-liv-ts.jpg`,
      "/assets/products/apna-liv-ts-1.jpeg",
      "/assets/products/apna-liv-ts-2.jpeg",
      "/assets/products/apna-liv-ts-3.jpeg",
      "/assets/products/apna-liv-ts-4.jpeg",
      "/assets/products/apna-liv-ts-5.jpeg",
      "/assets/products/apna-liv-ts-6.jpeg", 
      "/assets/products/apna-liv-ts-7.jpeg",
      "/assets/products/apna-liv-ts-8.jpeg",
      "/assets/products/apna-liv-ts-9.jpeg",
    ],
    composition: "Choline Chloride 500mg, Liver Extract, Yeast Extract, Tricholine Citrate, L-Lysine HCl, Niacinamide, Inositol, DL-Methionine, D-Pantothenol, Silymarin 200mg, Vit B12, Ferric Ammonium Citrate.",
    indications: [
      "Regenerates damaged liver cells",
      "Improves appetite & bile secretion",
      "Prevents fatty liver, anemia & jaundice",
    ],
    dosage: [
      ["Large Animal", "50–100 ml daily"],
      ["Small Animal", "25–50 ml daily"],
      ["Poultry Chicks", "10 ml / 100 birds"],
      ["Growers / Broilers", "200 ml / 100 birds"],
      ["Layers", "500 ml / 100 birds"],
    ],
    pack: "500 ml & 1 Litre",
    featured: true,
  },
  {
    slug: "minco-h",
    name: "Minco-H",
    category: "nutritional",
    categoryLabel: "Multivitamin",
    tagline: "Powerful Multivitamin for Udder Health & Immunity",
    images: [`${B}/minco-h.jpg`, 
      `${B}/minco-h-2.jpg`,
      "/assets/products/minco-h-1.jpeg",
      "/assets/products/minco-h-3.jpeg",
      "/assets/products/minco-h-4.jpeg",
      "/assets/products/minco-h-5.jpeg",
      "/assets/products/minco-h-6.jpeg",
      "/assets/products/minco-h-7.jpeg",
      "/assets/products/minco-h-8.jpeg",
    ],
    composition: "Vit A 25000 IU, Vit D3 12500 IU, Vit E 50mg, Vit H 500mcg, Selenium 6mcg, Vit C 50mcg, Zinc 18mg, Cobalt 100mcg.",
    indications: [
      "Prevents heat stress & mastitis",
      "Supports udder development & milk holding capacity",
      "Improves immunity, weight gain, fertility & sperm count",
    ],
    dosage: [
      ["Large Animal", "10 ml once daily"],
      ["Small Animal", "2–5 ml daily"],
      ["Poultry", "5–7 ml / 100 birds"],
    ],
    pack: "100 ml, 250 ml, 500 ml, 1 L, 5 L",
    featured: true,
  },
  {
    slug: "masta-go-bolus",
    name: "Masta-Go Bolus",
    category: "mastitis",
    categoryLabel: "Mastitis Care",
    tagline: "Pre & Post Treatment of Mastitis — A Unique Formula",
    images: [`${B}/masta-go.jpg`,
      "/assets/products/masta-go-1.jpeg",
      "/assets/products/masta-go-2.jpeg",
      "/assets/products/masta-go-3.jpeg",
      "/assets/products/masta-go-4.jpeg",
      "/assets/products/masta-go-5.jpeg",
      "/assets/products/masta-go-6.jpeg",
      ],
    composition: "Potassium Iodide, Trisodium, Tricholine Citrate, Vitamins & Trace Minerals, Serratiopeptidase, Chymotrypsin.",
    indications: [
      "Sub-clinical mastitis & prophylaxis",
      "Co-therapy in acute mastitis",
      "Reduces SCC, improves milk quality",
      "No milk withdrawal period — safe for udder",
    ],
    dosage: [
      ["Cow & Buffalo", "1 Bolus BD"],
      ["Sheep & Goat", "1 Bolus every alternate day up to 1 week"],
    ],
    pack: "2 x 1 x 7 Bolus",
    featured: true,
  },
  {
    slug: "dz-cloxa-4gm",
    name: "DZ Cloxa-4 gm",
    category: "antibiotics",
    categoryLabel: "Antibiotic",
    tagline: "Powerful & Synergistic Antibiotic Combination",
    images: [`${B}/dz-cloxa.jpg`,
      "/assets/products/dz-cloxa-4gm-1.jpeg",
    ],
    composition: "Amoxycillin 2 gm & Cloxacillin 2 gm Injection.",
    indications: [
      "Mastitis & metritis",
      "Respiratory infections",
      "Uterine infections",
    ],
    dosage: [["Standard Use", "As directed by veterinarian"]],
    pack: "4 gm Injection Vial",
    featured: true,
  },
  {
    slug: "tolfi-p",
    name: "Tolfi-P",
    category: "nsaids",
    categoryLabel: "NSAID",
    tagline: "Power-Packed NSAID — Pain, Inflammation & Fever",
    images: [`${B}/tolfi-p.jpg`,
      "/assets/products/tolfi-p-1.jpeg",
      "/assets/products/tolfi-p-2.jpeg",
      "/assets/products/tolfi-p-3.jpeg",
    ],
    composition: "Tolfenamic Acid Ph. Eur. 40mg + Paracetamol I.P. 150mg per ml.",
    indications: [
      "Musculoskeletal disorders",
      "Respiratory tract infection",
      "Mastitis & urogenital tract infection",
      "Perioperative care, laminitis",
    ],
    dosage: [
      ["Cattle / Buffalo / Sheep / Goat", "1 ml / 20 kg body wt. IM or SC"],
      ["Pig", "1 ml / 20 kg IM"],
    ],
    pack: "30 ml & 100 ml Injection Vial",
    featured: true,
  },
  {
    slug: "tick-maar-soap",
    name: "Tick-Maar Soap",
    category: "antiparasitics",
    categoryLabel: "Antiparasitic Soap",
    tagline: "Premium Veterinary Soap — Removes Ticks, Lice & Mites",
    images: [`${B}/tick-maar.jpg`,
      "/assets/products/tick-maar-1.jpeg",
      "/assets/products/tick-maar-2.jpeg",
      "/assets/products/tick-maar-3.jpeg",
    ],
    composition: "Permethrin 8%, Gamma Benzene 0.5%, Vitamin E 0.2%, Aloe Vera 1.0%, Cetrimide 1%.",
    indications: [
      "Effective against lice, mites, fleas & ticks",
      "For cattle, dogs, goats, buffaloes",
    ],
    dosage: [
      ["Large Animals", "Apply evening, leave overnight, wash in morning"],
      ["Pets", "Apply, leave 5–10 min then wash"],
    ],
    pack: "75 gm Soap",
    featured: true,
  },
  {
    slug: "utra-z-plus",
    name: "Utra-Z Plus",
    category: "uterine",
    categoryLabel: "Uterine Care",
    tagline: "Potent Ecbolic & Uterine Cleanser",
    images: [`${B}/utra-z.jpg`,
      "/assets/products/utra-z-plus-1.jpeg",
      "/assets/products/utra-z-plus-2.jpeg",
      "/assets/products/utra-z-plus-3.jpeg",
      "/assets/products/utra-z-plus-4.jpeg",
      "/assets/products/utra-z-plus-5.jpeg",
    ],
    composition: "Barnbusa Arundinacea, Solanum Xanthocarpum, Cirtullus Colocynthis, Aristolochia Indica, Piper Longum, Daucus Carota, Zingiber Officinal, Carum Copticum, Aloe Vera, Ferrous Sulphate, Cuprum Sulphas (Ayurvedic Veterinary).",
    indications: [
      "Retained placenta, pyometra, metritis",
      "Uterine bleeding, vaginal prolapse",
      "Anoestrous & repeat breeding",
      "Ensures >83.33% recovery",
    ],
    dosage: [
      ["After Parturition", "200 ml immediately, 200 ml after 6 hrs"],
      ["Follow-up", "100 ml twice daily for 3 days"],
      ["Large / Small Animal", "50–100 ml / 20–50 ml"],
    ],
    pack: "250 ml, 500 ml & 1 Litre",
    featured: true,
  },
  {
    slug: "dz-flox-injection",
    name: "DZ Flox Injection",
    category: "antibiotics",
    categoryLabel: "Antibiotic",
    tagline: "Broad Spectrum Levofloxacin for Respiratory & Systemic Infections",
    images: [`${B}/dz-flox.jpg`,
      "/assets/products/dz-flox-1.jpeg",
      "/assets/products/dz-flox-2.jpeg",
    ],
    composition: "Levofloxacin Hemihydrate I.P. 100mg, Benzyl Alcohol 1.5% w/v.",
    indications: [
      "Diarrhoea & dysentery",
      "Respiratory tract infections",
      "Metritis, pyometra",
      "Skin / soft tissue infections, pyrexia",
    ],
    dosage: [["Standard", "7.5–10 mg/kg body wt — 1 ml per 10–15 kg | IM, IV, SC"]],
    pack: "30 ml & 100 ml Injection Vial",
    featured: false,
  },
  {
    slug: "dz-flox-bolus",
    name: "DZ Flox Bolus",
    category: "antibiotics",
    categoryLabel: "Antibiotic",
    tagline: "Enrofloxacin 2000 mg — 1st Choice for Systemic Infections",
    images: [`${B}/dz-flox-bolus.jpg`],
    composition: "Enrofloxacin 2000 mg Bolus.",
    indications: [
      "Respiratory, urinary & skin infections",
      "GI tract infections",
      "Retained placenta",
      "Secondary viral infections",
    ],
    dosage: [
      ["Large Animals", "2 Bolus daily, 3–5 days"],
      ["Small Animals", "1 Bolus daily, 3–5 days"],
    ],
    pack: "1 x 2 Bolus",
    featured: false,
  },
  {
    slug: "fendi-z-plus-bolus",
    name: "Fendi'Z Plus Bolus",
    category: "antiparasitics",
    categoryLabel: "Antiparasitic",
    tagline: "For Safe Deworming in Pregnancy",
    images: [`${B}/fendi-z.jpg`,
      "/assets/products/fendi-z-plus-1.jpeg",
      "/assets/products/fendi-z-plus-2.jpeg",
      "/assets/products/fendi-z-plus-3.jpeg",
    ],
    composition: "Fenbendazole 3 gm & Ivermectin 100 mg Bolus.",
    indications: [
      "Fascioliasis in cattle, buffalo, sheep & goats",
      "Flukes, amphistomiasis, tapeworm (Moniezia)",
      "Ectoparasites (ticks & mites)",
    ],
    dosage: [
      ["Large Animals", "1–2 Bolus"],
      ["Small Animals", "1 Bolus"],
    ],
    pack: "1 x 1 Bolus",
    featured: false,
  },
  {
    slug: "endo-z-plus",
    name: "Endo-Z-Plus",
    category: "antiparasitics",
    categoryLabel: "Antiparasitic",
    tagline: "For Endo, Ecto Parasites & Maggoted Wounds",
    images: [`${B}/endo-z-plus.jpg`,
      "/assets/products/endo-z-plus-1.jpeg", 
      "/assets/products/endo-z-plus-2.jpeg",
      "/assets/products/endo-z-plus-3.jpeg",
    ],
    composition: "Albendazole 25 mg & Ivermectin 1 mg per ml Suspension.",
    indications: [
      "Fascioliasis, roundworms, lung worm",
      "Stomach, intestinal, nodular worms",
      "Hookworms, tapeworms & ectoparasites",
    ],
    dosage: [["Standard", "2–3 ml per 10 kg body weight"]],
    pack: "30 ml Suspension",
    featured: false,
  },
  {
    slug: "cefti-tz",
    name: "Cefti TZ",
    category: "antibiotics",
    categoryLabel: "Antibiotic",
    tagline: "Broad Spectrum Ceftiofur + Tazobactam for Serious Infections",
    images: [`${B}/cefti-tz.jpg`,
      "/assets/products/cefti-tz-1.jpeg",
    ],
    composition: "Ceftiofur Sodium eq. to Ceftiofur 1 gm + Tazobactam Sodium 125 mg per vial.",
    indications: [
      "Mastitis, metritis & endometritis",
      "Infectious bronchitis, pneumonia",
      "Bone, joint & soft tissue infections",
    ],
    dosage: [["Standard", "5–10 mg per kg body wt by IM or SC route"]],
    pack: "1125 mg Injection Vial",
    featured: false,
  },
  {
    slug: "liv-safe-b12",
    name: "Liv Safe B12",
    category: "liver",
    categoryLabel: "Liver Tonic",
    tagline: "A Liver Function Revitalizer",
    images: [`${B}/liv-safe-b12.jpg`,
      "/assets/products/liv-safe-b12-1.jpeg",
      "/assets/products/liv-safe-b12-2.jpeg",
    ],
    composition: "Thiamine HCL 10mg, Riboflavin 3mg, Niacinamide 50mg, Vit B12 20mcg, Folic Acid 1.5mg, Liver extract, Phenol 0.5% w/v.",
    indications: [
      "Hepatitis, jaundice & parasitic anemia",
      "Fatty liver, anorexia",
      "B-complex deficiency",
      "Improves production & hatchability in poultry",
    ],
    dosage: [
      ["Poultry Chicks", "5–10 ml / 100 birds"],
      ["Growers", "7.5–15 ml / 100 birds"],
      ["Layers", "10–20 ml / 100 birds"],
      ["Cattle", "20 ml daily for 10 days"],
    ],
    pack: "30 ml & 100 ml Injection Vial",
    featured: false,
  },
  {
    slug: "allergy-out",
    name: "Allergy Out",
    category: "allergy",
    categoryLabel: "Allergy / Antihistamine",
    tagline: "Fast Relief from Allergic Reactions in Livestock",
    images: [`${B}/allergy-out.jpg`,
      "/assets/products/AllergyOut.jpeg",
      "/assets/products/AllergyOut01.jpeg",
    ],

    composition: "Chlorpheniramine Maleate, Adrenaline & supporting actives — antihistamine and anti-allergic formulation. (Refer label for exact composition.)",
    indications: [
      "Acute allergic reactions, urticaria",
      "Insect bites, drug & vaccine reactions",
      "Pruritus, dermatitis & rhinitis",
      "Anaphylactic shock support",
    ],
    dosage: [
      ["Large Animal", "As directed by veterinarian"],
      ["Small Animal", "As directed by veterinarian"],
    ],
    pack: "30 ml & 100 ml Injection Vial",
    featured: false,
  },
];

export const FEATURED = PRODUCTS.filter((p) => p.featured).slice(0, 8);

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
